import React from 'react';
import "./PaginationComponent.css";

interface PaginationProps {
    pageNumbers: number[];
    currentPage: number;
    setCurrentPage: any;
    dataCount: number;
}

const PaginationComponent: React.FC<PaginationProps> = ({ pageNumbers, currentPage, setCurrentPage, dataCount }) => {
    const maxPageButtons = 5;
    let startPage, endPage;
    if (pageNumbers.length <= maxPageButtons) {
        startPage = 1;
        endPage = pageNumbers.length;
    } else {
        if (currentPage <= Math.ceil(maxPageButtons / 2)) {
            startPage = 1;
            endPage = maxPageButtons;
        } else if (currentPage + Math.floor(maxPageButtons / 2) >= pageNumbers.length) {
            startPage = pageNumbers.length - (maxPageButtons - 1);
            endPage = pageNumbers.length;
        } else {
            startPage = currentPage - Math.floor(maxPageButtons / 2);
            endPage = currentPage + Math.floor(maxPageButtons / 2);
        }
    }
    const paginationItems = [];
    for (let number = startPage; number <= endPage; number++) {
        paginationItems.push(
            <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                <a onClick={(e) => {
                    e.preventDefault();
                    setCurrentPage(number);
                }} className="page-link">
                    {number}
                </a>
            </li>
        );
    }
    return (
        dataCount > 0 ? (
            <div className="pagination-container border">
                <div className="d-flex justify-content-between align-items-center w-100 p-2">
                    <div className="d-none d-sm-flex align-items-center">
                        Sayfa {currentPage}/{pageNumbers[pageNumbers.length - 1]} ({dataCount})
                    </div>
                    <div>
                        <nav aria-label="">
                            <ul className="pagination pagination-primary mb-0">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <a className="page-link customPaginationLinkArrows" href="#" aria-label="Previous" onClick={(e) => {
                                        e.preventDefault();
                                        if (currentPage > 1) setCurrentPage(currentPage - 1);
                                    }}>
                                        <span aria-hidden="true">&lt;</span>
                                    </a>
                                </li>
                                {paginationItems}
                                <li className={`page-item ${currentPage === pageNumbers.length ? "disabled" : ""}`}>
                                    <a className="page-link customPaginationLinkArrows" href="#" aria-label="Next" onClick={(e) => {
                                        e.preventDefault();
                                        if (currentPage < pageNumbers.length) setCurrentPage(currentPage + 1);
                                    }}>
                                        <span aria-hidden="true">&gt;</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div>
                        <select className="form-select" value={currentPage} onChange={(e) => {
                            e.preventDefault();
                            setCurrentPage(Number(e.target.value));
                        }}>
                            {pageNumbers.map((number) => (
                                <option key={number} value={number}>{number} /sf.</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        ) : <div></div>
    );
};

export default PaginationComponent;
